import {
    disableForceInduct,
    enableForceInduct,
    automateForceInduct,
    fetchForceDetails,
} from "../network/InductManagementNetworkAPI";
import {DEFAULT_ALERT} from "../Constants";

export const ForceReducer = (state, action) => {
    switch (action.type) {
        case "LOAD_VIEW":
            fetchForceDetails(action.data.dispatcher)
            return state
        case "DISABLE_FORCE_CYCLE":
            disableForceInduct({cycleName: action.data.cycleName}, action.data.dispatcher)
            return state
        case "ENABLE_FORCE_CYCLE":
            enableForceInduct({cycleName: state.selectedCycleName}, action.data.dispatcher)
            return state
        case "AUTOMATE_FORCE_CYCLE":
            automateForceInduct({cycleName: state.selectedCycleName}, action.data.dispatcher)
            return state
        case "RECEIVE_DATA":
            return {...state, ...action.data}
        case "SET_ALERT":
            return {...state, alert: action.data}
        case "CLEAR_ALERT":
            return {...state, alert: DEFAULT_ALERT}
        case "SELECT_CYCLE":
            return {...state, selectedCycleName: action.data.cycleName}
        case "SELECT_FORCE_INDUCT_STATUS":
            return {...state, selectedForceInductStatus: action.data.forceInductStatus}
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/components/inductmanagementv2/reducer/ForceReducer.js